import { useMemo } from 'react'
import Big from 'big.js'
import { energyTableGetTotal, energyTableGetValues } from '../PowerOverviewEnergyTable'
import { useQuery, useSuspenseQuery } from '@apollo/client'
import { GET_WINDOWED_MEASUREMENTS_QUERY } from '../../../../energy/queries/metrics'
import { useRecoilValue } from 'recoil'
import { building, timeframe } from '../../../../store'
import { getTimeframe, TimeframeVariant } from '../../../../utils/getTimeframe'
import { GetGridForPowerOverviewQuery } from '../../../queries/gridForPowerOverview'
import { EnergyTableSingleCategoryColumn } from '../../../../components/Energy/EnergyTable/EnergyTableSingleCategoryColumn'
import { EnergyTypes } from '../../../../components/Energy/EnergyTable/EnergyTableResult'

interface PowerOverviewImportColumnProps {
  maxForBarChart: number
}

export const PowerOverviewExportColumn = ({ maxForBarChart }: PowerOverviewImportColumnProps) => {
  const { activeBuildingId } = useRecoilValue(building)
  const selectedTimeframe = useRecoilValue(timeframe)
  const { start, end, window } = getTimeframe({ ...selectedTimeframe, variant: TimeframeVariant.CONDENSED })

  const { data: gridLayoutData } = useSuspenseQuery(GetGridForPowerOverviewQuery, {
    variables: {
      buildingId: activeBuildingId
    },
    skip: !Boolean(activeBuildingId)
  })

  const { data: energyExported } = useSuspenseQuery(GET_WINDOWED_MEASUREMENTS_QUERY, {
    variables: {
      input: {
        deviceId: gridLayoutData?.getBuilding?.grid?.main?.map(entry => entry.deviceId) ?? [],
        start,
        end,
        measurement: 'energyExported',
        window
      }
    },
    fetchPolicy: 'no-cache',
    skip: !Boolean(gridLayoutData?.getBuilding?.grid?.main && gridLayoutData?.getBuilding?.grid?.main?.length > 0)
  })

  const gridExported = useMemo(() => {
    if (!energyExported?.getWindowedMeasurements || energyExported.getWindowedMeasurements.length < 1)
      return {
        total: 0,
        values: []
      }

    const total = energyTableGetTotal(energyExported.getWindowedMeasurements)
    const values = energyTableGetValues(energyExported.getWindowedMeasurements, selectedTimeframe)

    return {
      total: total.round(0, Big.roundHalfUp).toNumber(),
      values
    }
  }, [energyExported?.getWindowedMeasurements, selectedTimeframe])

  return <EnergyTableSingleCategoryColumn title={'Export'} type={EnergyTypes.Export} total={gridExported.total} resultMax={maxForBarChart} values={gridExported.values} />
}
